<template>
    <el-footer style="height:872px">
      <el-container class="d-flex-column">
        <el-row :gutter="24">
            <el-col :span="6">
              <el-menu :router="true" :default-active="activeLink" class="el-menu-demo" mode="vertical" @open="handleSelect">
                  <template v-if="currentLanguage == 'en'" v-for="(footermenu, index) in footerList">
                      <el-menu-item :index="footermenu.path" :key="index">
                          {{ footermenu.footermenuname }}
                      </el-menu-item>
                  </template>
                  <template v-if="currentLanguage == 'ar'" v-for="(footermenu, index) in footerArList">
                      <el-menu-item :index="footermenu.path" :key="index">
                          {{ footermenu.footermenuname }}
                      </el-menu-item>
                  </template>
              </el-menu>
            </el-col>
            <el-col :span="18" class="text-right">
              <a @click="$router.push('/')" href="javascript:void(0);" class="footer-brand">
                <img alt="Maren Logo" class="logo" src="../../../public/img/logo.svg" width="220" />
              </a>
            </el-col>
          </el-row>
          <div class="footer-bar">
            <el-row :gutter="24">
              <el-col :span="16">
                <ul class="footer-list">
                  <li class="footer-item"><a href="javascript:void();" class="footer-link">© {{new Date().getFullYear()}} Maren Solutions</a></li>
                  <li class="footer-item"><a href="javascript:void();" class="footer-link">Privacy Policy</a></li>
                  <li class="footer-item"><a href="javascript:void();" class="footer-link">Cookie Policy</a></li>
                  <li class="footer-item"><a href="javascript:void();" class="footer-link">Terms & Conditions</a></li>
                </ul>
              </el-col>
              <el-col :span="8" class="social">
                  <a rel="nofollow" data-tracker="LINKEDIN" class="linkedIn" target="_blank" href=""><i class="icon-linkedin"></i></a>
                  <a rel="nofollow" data-tracker="FACEBOOK" class="facebook" target="_blank" href=""><i class="icon-facebook"></i></a>
                  <a rel="nofollow" data-tracker="TWITTER" class="twitter" target="_blank" href=""><i class="icon-twitter"></i></a> 
                  <a rel="nofollow" data-tracker="INSTAGRAM" class="instagram" target="_blank" href=""><i class="icon-instagram"></i></a>
              </el-col>
            </el-row>
          </div>
      </el-container>
    </el-footer>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["locale", "currentLanguage"]),

  // mounted: function () {
  //           this.activeLink = match.path;
  //       },
  data () {
    return {
      renderLocale: {},
      activeLink: null,
      footerList:[
        {
          "footermenuname":"Home",
          "path":"/"
        },
        {
          "footermenuname":"About us",
          "path":"/aboutus"
        },
        {
          "footermenuname":"Products",
          "path":"/products"
        },
        {
          "footermenuname":"Our team",
          "path":"/our-team"
        },
        {
          "footermenuname":"Awards & Events",
          "path":"/awards-events"
        },
        {
          "footermenuname":"Memories",
          "path":"/memories"
        },
        {
          "footermenuname":"Touch with Us",
          "path":"/contactus"
        }
      ],
      footerArList:[
        {
          "footermenuname":"Home",
          "path":"/"
        },
        {
          "footermenuname":"About us",
          "path":"/aboutus"
        },
        {
          "footermenuname":"Products",
          "path":"/products"
        },
        {
          "footermenuname":"Our team",
          "path":"/our-team"
        },
        {
          "footermenuname":"Awards & Events",
          "path":"/awards-events"
        },
        {
          "footermenuname":"Memories",
          "path":"/memories"
        },
        {
          "footermenuname":"Touch with Us",
          "path":"/contactus"
        }
      ]  
    }
  },
  watch: {
    locale: {
      immediate: true,
      handler() {
        if (this.locale) {
          this.renderLocale = this.locale;
        }
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      }
    }
}
</script>



// WEBPACK FOOTER //
// Footer.vue